module.exports = __webpack_public_path__ + "static/media/google.e4eac8b1.svg";